<template>
  <bm-btn
    button-type="ghost"
    v-bind="$attrs"
    :data-qa="value ? keys.less : keys.more"
    @click="toggle"
    >{{
      value
        ? lessTextOverride || messages.less
        : moreTextOverride || messages.more
    }}
    <bm-icon v-if="!value" icon="ExpandMore" />
    <bm-icon v-if="value" icon="ExpandLess" />
  </bm-btn>
</template>

<script setup lang="ts">
import messages, { keys } from "@/plugins/i18n";
import BmBtn from "@/components/controls/input/BmBtn.vue";

interface BmBtnExpandProps {
  moreTextOverride?: string;
  lessTextOverride?: string;
  value: boolean;
}

const props = withDefaults(defineProps<BmBtnExpandProps>(), {
  moreTextOverride: "",
  lessTextOverride: "",
});

interface BmBtnExpandEvents {
  (event: "update:value", value: boolean): void;
}

const emit = defineEmits<BmBtnExpandEvents>();

const toggle = () => {
  emit("update:value", !props.value);
};
</script>
